import { Box, CircularProgress, Typography } from '@mui/material';

export const CopilotLoadingState = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 2 }}>
    <CircularProgress size={20} />
    <Typography variant="body2" color="text.secondary">
      G.AI is reviewing the available context...
    </Typography>
  </Box>
);
